import { useEffect } from 'react';

import { isCollapseLoadingBarEnabled } from '../utils/collapse-loading-bar-enabled';

/**
 * Logs the canonical exposure for the collapsible loading bar experiment.
 *
 * Pass the conditions that decide whether a loading bar is on screen for this user. Those
 * conditions must be arm-independent: deriving them from the experiment value would enrol the
 * test cohort only, leaving the readout without a control arm.
 *
 * Render paths keep using `isCollapseLoadingBarEnabledNoExposure`, so the bar is only ever
 * enrolled once per surface rather than on every re-render.
 */
export const useCollapseLoadingBarExposure = (isLoadingBarVisible: boolean): void => {
	useEffect(() => {
		if (!isLoadingBarVisible) {
			return;
		}

		isCollapseLoadingBarEnabled();
	}, [isLoadingBarVisible]);
};
